module.exports = __webpack_public_path__ + "static/media/bigCheck.233ae859.svg";